import EditLocation from '@/components/edit-location';

export default EditLocation;
